module.exports = __webpack_public_path__ + "img/aliorbank.c14a01e4.png";